export const moduleOptions = [
    { label: 'Dashboard', route: '/dashboard' },
    { label: 'Company Master', route: '/masters/companytable' },
    { label: 'User Master', route: '/userMasterTable' },
    { label: 'Employee Master', route: '/employeetable' },
    { label: 'Employee Type Master', route: '/employeetypetable' },
    { label: 'Designation Master', route: '/designationtable' },
    { label: 'Payment Plan Master', route: '/roomPlanTable' },
    { label: 'Promocode Master', route: '/promotable' },
    { label: 'Coupon Authority', route: '/couponAuthorityTable' },
    { label: 'Coupon Master', route: '/generate-coupon-table' },
    { label: 'Topup Master', route: '/Topup_Table' },
    { label: 'Transport Plan', route: '/transport-plan-table' },
    { label: 'Mess Plan', route: '/mess-plan-table' },
    // First Grid
    { label: 'Property Master', route: '/propertytable' },
    { label: 'Room Master', route: '/room-master-table' },
    { label: 'Bed Master', route: '/roomBednumbertable' },
    { label: 'Wing Master', route: '/wingtable' },
    { label: 'Floor Master', route: '/floortable' },
    { label: 'PropertyType Master', route: '/propertyTypetable' },
    { label: 'Room Type Master', route: '/roomTypetable' },
    { label: 'BedType Master', route: '/roomBedTypetable' },
    { label: 'Room View', route: '/roomViewtable' },
    { label: 'Facilities Master', route: '/facilitiesmastertable' },
    { label: 'Amenities Master', route: '/amenitytable' },
    { label: 'Common Area', route: '/commonareatable' },
    { label: 'Generate Calender', route: '/generatecalender' },

    // Second Grid
    { label: 'Resident Master', route: '/masters/residenttable' },
    { label: 'Vendors & Creditors', route: '/partytable' },
    { label: 'Corporate Master', route: '/corporateTable' },
    { label: 'Institute Master', route: '/instituteMasterTable' },
    { label: 'Course Master', route: '/coursetable' },
    { label: 'Semester Master', route: '/semestertable' },
    { label: 'Source Master', route: '/sourceMstTable' },
    { label: 'Bank Master', route: '/bank-table' },
    { label: 'Relation Master', route: '/relation-table' },
    { label: 'Class Master', route: '/classtable' },
    { label: 'Rating Master', route: '/ratingtable' },

    // Third Grid
    { label: 'Category Master', route: '/categorytable' },
    { label: 'Group Master', route: '/grptable' },
    { label: 'SubGroup Master', route: '/subgrptable' },
    { label: 'Assets/Store Master', route: '/assettable' },
    { label: 'Unit Master', route: '/unittable' },

    // Fourth Grid
    { label: 'Main Group', route: '/maingrptable' },
    { label: 'Groups', route: '/groupmsttable' },
    { label: 'SubGroups', route: '/subgrpmsttable' },
    { label: 'Ledgers', route: '/ledgertable' },
    { label: 'Other Charges', route: '/otherchargestable' },
    { label: 'Billing Scheme', route: '#' },

    // Fifth Grid
    { label: 'Ticket Category', route: '/ticket-category-table' },
    { label: 'Warden/Vendor Allocation', route: '/warden-allocation-table' },
    { label: 'Ticket SubCategory', route: '/ticket-subcategory-table' },
    { label: 'Service/Complaint Master', route: '/service-table' },
    { label: 'Ticket Status', route: '/ticket-status' },

    // Sixth Grid (duplicate of third grid - removed duplicates)
    
    // Seventh Grid
    { label: 'House Keeping Type Master', route: '/hk-typetable' },
    { label: 'House Keeping', route: '#' },
    { label: 'Machine Master', route: '#' },
    { label: 'Maintenance Type', route: '#' },
    { label: 'Maintenance Master', route: '#' },
    { label: 'Vehicle Master', route: '#' },
    { label: 'Shift Master', route: '/masters/shift-table' },

    // Eighth Grid
    { label: 'Module Rights', route: '/module-rights-table' },
    { label: 'User Rights', route: '/userpermission' },
    { label: 'Audit Trail', route: '/audit-report' },
    { label: 'Email Configuration', route: '/emailconfig-table' },
    { label: 'Payment Gateway Configuration', route: '/paymentGatewayConfigTable' },
    { label: 'Send Email', route: '/send-email' },
    { label: 'Bill Generation', route: '#' },
    
    { label: 'Enquiry', route: '/enquirytable' },
    { label: 'Follow-Ups', route: '/TableFollowUp' },
    { label: 'Booking', route: '/bookingtable' },
    { label: 'Booking Confirmation', route: '/BookingConfirmTable' },
    { label: 'Check-In', route: '/enquiry/checkintable' },
    { label: 'Check-Out', route: '/enquiry/CheckoutTable' },
    { label: 'Payment Advice', route: '/advicegeneratetable' },
    { label: 'Receipt', route: '/receipt-table' },
    { label: 'Refund', route: '/enquiry/refund' },
    { label: 'Plan Calculation', route: '/calculation' },
    { label: 'Transaction TopUp', route: '/trntopuptable' },
    
    // From second Grid section
    { label: 'Ticket Generation', route: '#' },
    { label: 'Ticket Dashboard', route: '/raise-tkt-dashboard' },
    { label: 'Raise Service Ticket', route: '/raise-service-tkt' },
    { label: 'Task Assignment', route: '/task-assignment' },
    { label: 'Task Acceptance', route: '/task-acceptance' },

    { label: 'MPR Calendor', route: '/operations/menpower-calendar' },
    { label: 'Attendance', route: '#' },
    { label: 'Man Power Deploymen', route: '#' },
    { label: 'Quality Checking & Control(QCS)', route: '#' },
    
    // Add the new options from your Grid components
    { label: 'Inward GRN', route: '/inventory/GRNTable' },
    { label: 'Asset Allocation', route: '/assetallocationtable' },
    { label: 'Asset Transfer', route: '/assettransfertable' },
    { label: 'Store Issue', route: '#' },
    { label: 'Bed Reports', route: '/bedreporttable' },
    { label: 'Booking details', route: '/reports/bookingdetails' },
    { label: 'Booking Summary', route: '/Booking' },
    { label: 'General Ledger', route: '#' },
    { label: 'Cash Book', route: '#' },
    { label: 'Bank Book', route: '#' },
    { label: 'Purchase Register', route: '#' },
    { label: 'Trial Balance', route: '#' },
    { label: 'Balance Sheet', route: '#' },
    { label: 'User & Permission', route: '/userpermission' },
    { label: 'New Calender', route: '/newcalender' },
  ];
  
  export const getLinkForModule = (moduleName) => {
    const foundModule = moduleOptions.find(module => module.label === moduleName);
    return foundModule ? foundModule.route : '#';
  };